import { ApiService as api } from '@/services/axiosHelper';
import {
	SET_CUSTOMER,
	TOAST_MESSAGES_PUSH,
	SET_CUSTOMER_FEATURES,
	SET_LOADING_CUSTOMER_FEATURES,
	SET_ERROR_LOGS,
	SET_ERROR_LOGS_USERS,
	CLEAR_ERROR_LOGS_USERS
} from './mutation-types';
import buildRoute from '@/composables/build-route';
import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'customer',
	namespaced: true,
	state: {
		customer: {},
		customerFeatures: {},
		loadingCustomerFeatures: false,
		errorLogs: {},
		errorLogsUsersOptions: []
	},
	mutations: {
		[SET_CUSTOMER](state, customer) {
			state.customer = customer;
		},
		[SET_CUSTOMER_FEATURES](state, customerFeatures) {
			state.customerFeatures = customerFeatures;
		},
		[SET_LOADING_CUSTOMER_FEATURES](state, value) {
			state.loadingCustomerFeatures = value;
		},
		[SET_ERROR_LOGS](state, value) {
			state.errorLogs = value;
		},
		[SET_ERROR_LOGS_USERS](state, users) {
			state.errorLogsUsersOptions = users;
		},
		[CLEAR_ERROR_LOGS_USERS](state) {
			state.errorLogsUsersOptions = [];
		}
	},
	actions: {
		async loadCustomerById({ commit, dispatch }, id) {
			await api
				.get(`/customer/${id}`)
				.then(res => {
					commit(SET_CUSTOMER, res);
					return res;
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: error
						},
						{
							root: true
						}
					);
				});
		},
		async [SET_CUSTOMER_FEATURES]({ commit, dispatch }, id) {
			if (!id) {
				commit(SET_CUSTOMER_FEATURES, {});
				dispatch(
					TOAST_MESSAGES_PUSH,
					{
						statusCode: 400,
						message: `Client Id is required.`
					},
					{
						root: true
					}
				);
				return;
			}
			let hasResultValue = false;
			commit(SET_LOADING_CUSTOMER_FEATURES, true);

			await api
				.get(`customers/${id}/features`)
				.then(res => {
					if (_.get(res, 'features', []).length > 0) {
						hasResultValue = true;
						commit(SET_CUSTOMER_FEATURES, res);
					} else {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message:
									'Beta features are not available for this client.'
							},
							{
								root: true
							}
						);
					}
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: error
						},
						{
							root: true
						}
					);
				});

			commit(SET_LOADING_CUSTOMER_FEATURES, false);
			return hasResultValue;
		},
		async getErrorLogs({ commit, dispatch }, parameters) {
			commit(SET_ERROR_LOGS, []);

			return new Promise((resolve, reject) => {
				api.get(buildRoute(`/errorLogs`, parameters))
					.then(resp => {
						commit(SET_ERROR_LOGS, resp);
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject(error);
					});
			});
		},
		async getErrorLogsUsers({ commit, dispatch }, parameters) {
			commit(CLEAR_ERROR_LOGS_USERS);
			return new Promise((resolve, reject) => {
				api.get(buildRoute(`/errorlogs/users`, parameters))
					.then(res => {
						let cloneResp = _.cloneDeep(res);
						const uniqueUserIds = new Set();
						const uniqueUsers = cloneResp.items.filter(item => {
							if (!uniqueUserIds.has(item.value)) {
								uniqueUserIds.add(item.value);
								return true;
							}
							return false;
						});

						commit(SET_ERROR_LOGS_USERS, uniqueUsers);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async saveErrorLogsResolutions({ dispatch }, payload) {
			const { action, displayToast, ...payloadWithoutAction } = payload;
			let isSuccessful = true;
			let statusCode = 200;
			let verbiage = 'success';

			await api
				.post('/errorlogs/resolutions', payloadWithoutAction)
				.then(() => {})
				.catch(() => {
					isSuccessful = false;
					verbiage = 'unsuccess';
					statusCode = 400;
				});

			if (displayToast) {
				if (['add', 'edit'].includes(action)) {
					verbiage = verbiage + 'fully';
				}

				const generateToastMessage = () => {
					if (['resolved', 'unresolved'].includes(action)) {
						const { logTickets } = payloadWithoutAction;
						const recordsToUpdateCount = logTickets.length;
						return `${verbiage.charAt(0).toUpperCase() +
							verbiage.slice(1)}! ${recordsToUpdateCount} ${
							recordsToUpdateCount === 1 ? 'error' : 'errors'
						} ${action}`;
					}

					return `Comment ${verbiage} ${
						action === 'add' ? 'added' : 'updated'
					}`;
				};
				const message = generateToastMessage();

				dispatch(
					TOAST_MESSAGES_PUSH,
					{
						userIcon: true,
						statusCode,
						message
					},
					{
						root: true
					}
				);
			}

			return isSuccessful;
		}
	},
	getters: {
		customer: state => state.customer,
		customerFeatures: state => state.customerFeatures,
		loadingCustomerFeatures: state => state.loadingCustomerFeatures
	}
};
